import { useNavigate, useLocation } from "react-router-dom";
import { LayoutGrid, Users, Zap, Map, Disc3 } from "lucide-react";

const TABS = [
  { path: "/dashboard",         icon: LayoutGrid, label: "Collection", color: "#b44fff" },
  { path: "/friends",           icon: Users,       label: "Friends",    color: "#ff3cac" },
  { path: "/scan",              icon: Zap,         label: "Scan",       color: null, isFab: true },
  { path: "/map",               icon: Map,         label: "Map",        color: "#00f5ff" },
  { path: "/dashboard?tab=stage", icon: Disc3,     label: "My Stage",   color: "#ffd700" },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const user     = JSON.parse(localStorage.getItem("user") || "null");

  // Hidden on landing, login, kandi public pages
  const hidden = ["/", "/login"].includes(location.pathname)
    || location.pathname.startsWith("/kandi/");
  if (hidden || !user) return null;

  const isActive = (path) => {
    const base = path.split("?")[0];
    if (base === "/dashboard") {
      if (location.pathname !== "/dashboard") return false;
      const onStage = location.state?.tab === "profile";
      return path === "/dashboard?tab=stage" ? onStage : !onStage;
    }
    return location.pathname === base;
  };

  const handleTab = (tab) => {
    if (tab.path === "/dashboard?tab=stage") {
      navigate("/dashboard", { state: { tab: "profile" } });
    } else if (tab.path === "/dashboard") {
      navigate("/dashboard", { state: { tab: "collection" } });
    } else {
      navigate(tab.path);
    }
  };

  return (
    <>
      <nav style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 200,
        height: 72,
        background: "rgba(8,4,18,0.95)",
        backdropFilter: "blur(24px)",
        WebkitBackdropFilter: "blur(24px)",
        borderTop: "1px solid rgba(255,255,255,0.08)",
        // display is owned by .bottom-nav in index.css: none on desktop,
        // flex on ≤768px. An inline display here would render the tab bar
        // (and pulsing FAB) on top of the desktop navbar.
        alignItems: "center",
        justifyContent: "space-around",
        paddingBottom: "env(safe-area-inset-bottom)",
        boxShadow: "0 -8px 32px rgba(0,0,0,0.5)",
      }}
        className="bottom-nav"
      >
        {TABS.map((tab) => {
          const active  = isActive(tab.path);
          const Icon    = tab.icon;

          if (tab.isFab) {
            return (
              <button
                key={tab.path}
                onClick={() => handleTab(tab)}
                style={{
                  position: "relative",
                  top: -18,
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #ff3cac, #b44fff)",
                  border: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 0 0 4px rgba(180,79,255,0.2), 0 0 24px rgba(255,60,172,0.6), 0 4px 20px rgba(0,0,0,0.5)",
                  touchAction: "manipulation",
                  flexShrink: 0,
                }}
                className="fab-scan"
              >
                <Icon size={26} color="#fff" style={{ filter: "drop-shadow(0 0 6px rgba(255,255,255,0.8))" }} />
              </button>
            );
          }

          return (
            <button
              key={tab.path}
              onClick={() => handleTab(tab)}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 4,
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "8px 16px",
                minWidth: 52,
                touchAction: "manipulation",
                flexShrink: 0,
              }}
            >
              <div style={{
                width: 36,
                height: 36,
                borderRadius: 12,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: active ? `${tab.color}22` : "transparent",
                transition: "all 0.2s",
              }}>
                <Icon
                  size={22}
                  style={{
                    color: active ? tab.color : "rgba(255,255,255,0.35)",
                    filter: active ? `drop-shadow(0 0 6px ${tab.color})` : "none",
                    transition: "all 0.2s",
                  }}
                />
              </div>
              <span style={{
                fontSize: "0.6rem",
                fontWeight: active ? 700 : 500,
                color: active ? tab.color : "rgba(255,255,255,0.3)",
                letterSpacing: "0.04em",
                textTransform: "uppercase",
                transition: "color 0.2s",
              }}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </nav>

    </>
  );
}
